import Components from '../Components'
import type { RouteDefinitions } from '../Router'
import addressBookRoutes from './addressBookRoutes'
import HpSettingsRedirect from './HpSettingsRedirect'

const businessProfileRoutes = {
  businessprofilesettings: {
    path: '/settings/business-profile',
    exact: true,
    component: (
      <HpSettingsRedirect hpTemplate="/buy/my-account/business-profile">
        <Components.BusinessProfileSettingsPage />
      </HpSettingsRedirect>
    ),
    requireAuth: true,
  },
  businessprofilebuyingeligibility: {
    path: '/settings/business-profile/:accountId/buying-eligibility',
    exact: true,
    component: (
      <HpSettingsRedirect hpTemplate="/buy/my-account/business-profile/:accountId/buying-eligibility">
        <Components.BusinessProfileBuyingEligibility />
      </HpSettingsRedirect>
    ),
    requireAuth: true,
  },
  createBusinessProfile: {
    path: '/settings/business-profile/:accountId/:personId/business-info',
    exact: true,
    component: (
      <HpSettingsRedirect hpTemplate="/buy/my-account/business-profile/:accountId/:personId/business-info">
        <Components.CreateBusinessProfile />
      </HpSettingsRedirect>
    ),
    requireAuth: true,
  },
  'address-book': {
    router: true,
    path: '/settings/business-profile/:accountId/address-book',
    routes: addressBookRoutes,
  },

  // Old paths
  businessprofilebusinesseligibility: {
    path: '/settings/business-profile/:accountId/business-eligibility',
    exact: true,
    requireAuth: true,
    redirectTo: '/settings/business-profile/:accountId/buying-eligibility',
  },
} as const satisfies RouteDefinitions

export default businessProfileRoutes
